(function () {
    'use strict';

    angular.module("imApp").factory("productDataHarvestService", ['$ihttp', function ($ihttp) {
        let service = {
            getProductDataHarvest: function (parms) {
                return $ihttp.post({
                    method: 2590,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
